var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"col-lg-6 col-md-6 col-sm-12"},[_c('topper-card',{attrs:{"data":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }